import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash-es";
import { qs } from "../lib/helpers";
import PageLoader from "../lib/page_loader";

export default class extends Controller {
  static values = { url: String };
  static targets = ["inputField"];

  initialize() {
    this.onChange = debounce(this.onChange, 300).bind(this);
    this.observer = new MutationObserver(this.onChange);
  }

  connect() {
    this.inputFieldTargets.forEach((target) => {
      this.observer.observe(target, {
        attributeFilter: ["value"],
      });
      target.addEventListener("change", this.onChange);
      target.addEventListener("input", this.onChange);
    });

    this.isConnected = true;
  }

  disconnect() {
    this.observer.disconnect();
    this.isConnected = false;
  }

  inputFieldTargetConnected(element) {
    this.observer.observe(element, {
      attributeFilter: ["value"],
    });
    element.addEventListener("change", this.onChange);
    element.addEventListener("input", this.onChange);
    this.onChange();
  }

  onChange() {
    let queryObject = {};
    for (const target of this.inputFieldTargets) {
      queryObject[target.name] = target.value;
    }

    const url = `${this.urlValue}?${qs(queryObject)}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        if (this.isConnected) {
          PageLoader.updateDOM(
            html,
            "[data-maintenance-plan-action-price-target='highUnitPriceWarning']"
          );
          PageLoader.updateDOM(
            html,
            "[data-maintenance-plan-action-price-target='totalPriceAndEmission']"
          );
        }
      });
  }
}
